query Company($id: String) {
  company(id: $id) {
    id
    ambassador {
      id
      email
    }
  }
}
